import React from "react";
import loginImage from "../../../assets/images/admin-login-banner.jpg";

function SideImage() {
  return (
    <div className="login-image-div">
      <img src={loginImage} alt="icon" />
    </div>
  );
}

export default SideImage;
